// extracted by mini-css-extract-plugin
export default {"AccordionBody":"FilterAccordion_AccordionBody__4pFdv"};